<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>Olá! Vamos começar a avaliação comportamental da sua equipe?</h2>
    </div>
    <div>
      <h2>Analise os comportamentos da sua equipe</h2>
      <p>
        Os comportamentos aparecerão na sua tela e, logo abaixo, aparecerá o
        nome de cada pessoa que trabalha no seu setor. Ao lado de cada nome,
        aparecerá uma escala que vai de
        <span class="info--text">"Nunca"</span> a
        <span class="info--text">"Sempre"</span>.
      </p>
    </div>
    <div>
      <h2>Analise a frequência dos comportamentos da sua equipe</h2>
      <p>
        Clique na estrela que representa a frequência que o membro da sua equipe
        apresentou o comportamento indicado durante o período estabelecido.
      </p>
      <p>
        <span class="error--text">Atenção!</span>, Caso você apresente, no
        período avaliado, motivos que impeçam a avaliação dos pares, clique em
        <span class="info--text">“Não é possível avaliar”</span>
        e selecione uma das opções indicadas.
      </p>
    </div>
    <div>
      <h2>Importante!</h2>
      <p class="info--text">
        Lembre-se! Você deverá avaliar os membros da sua equipe que trabalham no
        mesmo turno e espaço físico que você. Essa avaliação nos ajudará a
        construir a trilha de desenvolvimento da sua unidade.
      </p>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../BaseTutorial';

export default {
  name: 'TutorialAvaliacaoPares',

  components: { BaseTutorial },

  data() {
    return {
      steps: ['Introdução', 'Comportamentos', 'Frequência dos comportamento', 'Importante'],
    };
  },
};
</script>
